import React from "react"
import PillFilter from "./../general/PillFilter"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class Header extends React.Component{
    constructor(){
        super()
        //check if the search and filter is sticky. add shadow if it's sticky
        this.observer = new IntersectionObserver(function(entries) {
            // no intersection
            if (entries[0].intersectionRatio === 0){
                document.querySelector("#searchFilter").classList.add("shadow")
            }
            // fully intersects
            else if (entries[0].intersectionRatio === 1){
                document.querySelector("#searchFilter").classList.remove("shadow")
            }
            }, {
            threshold: [0, 1]
        });
    }
    componentDidMount(){
        this.observer.observe(document.querySelector("#galleryHeader"))
    }
    componentWillUnmount(){
        this.observer.unobserve(document.querySelector("#galleryHeader"))
    }
    render(){
        return(
            <>
            <h1 id="galleryHeader">All Games</h1>
            <div id="searchFilter" role="navigation">
                <div className="searchIconGroup">
                    <input aria-label="Search" id="searchBar" role="search" type="text" placeholder="Search for your game!" onChange={this.props.handleSearch}/>
                    <FontAwesomeIcon icon={faSearch} />
                </div>
                <div className="filters">
                    <PillFilter filterName="greenlit projects" toggleFilter={this.props.toggleGreenlitFilter}/>
                </div>
            </div>
            </>
        )
    }
}

export default Header